<template>
  <div style="padding: 0px 24px;">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="门店">
        <el-select v-model="formInline.md" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始年月">
        <el-date-picker type="date" placeholder="选择日期" v-model="formInline.ksny"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束年月">
        <el-date-picker type="date" placeholder="选择日期" v-model="formInline.jsny"></el-date-picker>
      </el-form-item>
      <el-form-item label="合同号">
        <el-input v-model="formInline.hth"></el-input>
      </el-form-item>
      <el-form-item label="商户名">
        <el-input v-model="formInline.shm"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" class="chaxun">查询</el-button>
        <!-- <el-button type="warning" @click="getList" class="chaxun">重置</el-button> -->
      </el-form-item>
    </el-form>
    <!-- <el-table :data="tableData" :height="conheight" style="width: 100% !important;border-top: 1px solid #000 !important;border-left: 1px solid #000 !important;"> -->
    <el-table :data="tableData" :height="conheight" style="width: 100% !important;" border>
      <el-table-column label="序号" width="50"><template slot-scope="scope">{{scope.$index+1}}</template></el-table-column>
      <el-table-column prop="FDMC" label="门店" width="110"></el-table-column>
      <el-table-column prop="WLDW_NAME" label="商户名"></el-table-column>
      <el-table-column prop="YEARMONTH" label="月结" width="60"></el-table-column>
      <el-table-column prop="JLBH" label="单据号" width="80"></el-table-column>
      <el-table-column prop="HTH" label="合同号" width="80"></el-table-column>
      <el-table-column prop="HSFS" label="核算方式" width="80"></el-table-column>
      <el-table-column prop="HTYXQ_START" label="合同起始时间" width="100"></el-table-column>
      <el-table-column prop="HTYXQ_END" label="合同终止时间" width="100"></el-table-column>
      <el-table-column prop="JSJE" label="结算净额" width="80"></el-table-column>
      <el-table-column prop="ZZSJE" label="结算税金" width="80"></el-table-column>
      <el-table-column prop="XSJE" label="销售金额" width="80"></el-table-column>
      <el-table-column prop="DEPT_NAME" label="部门" width="80"></el-table-column>
      <el-table-column prop="TQJS" label="提前结算" width="80"></el-table-column>
      <el-table-column prop="KKJE" label="扣款金额(成本)" width="80"></el-table-column>
      <el-table-column prop="KKJE_FY" label="扣款费用(现金)" width="80"></el-table-column>
      <el-table-column prop="KKJE_FYHK" label="	扣款费用(货扣)" width="80"></el-table-column>
      <el-table-column prop="FKJE" label="付款金额" width="80"></el-table-column>
      <el-table-column prop="ZKFTJE" label="折扣金额" width="80"></el-table-column>
      <el-table-column prop="XSCB" label="销售成本" width="80"></el-table-column>
      <el-table-column label="操作" width="140">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="light" placement="bottom">
            <span class="menuname"><el-link icon="el-icon-printer">打印</el-link></span>
            <div slot="content">
              <p><el-button type="success" icon="el-icon-printer" @click="print(scope.row,'fkqkd')">打印付款请款单</el-button></p>
              <p><el-button type="success" icon="el-icon-printer" @click="print(scope.row,'kpqrd')">打印开票确认单</el-button></p>
            </div>
          </el-tooltip>
          <span class="menuname">
            <el-link icon="el-icon-download" @click="OpenDialog(scope.row)">查看发票</el-link>
          </span>
        </template>
    </el-table-column>
    </el-table>
    <el-drawer title="发票明细" :visible.sync="dialogTableVisible"  direction="rtl"  size="50%">
      <el-table :data="gridData" :height="conheight" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">{{scope.$index+1}}</template>
        </el-table-column>
        <el-table-column property="f_pp" label="品牌"></el-table-column>
        <el-table-column property="f_kpny" label="开票年月"></el-table-column>
        <el-table-column property="f_fyxm" label="费用项目"></el-table-column>
        <el-table-column property="f_fyje" label="费用金额"></el-table-column>
        <el-table-column property="f_pdfwj" label="发票文件">
          <template slot-scope="scope">
            <span class="menuname">
              <el-link icon="el-icon-position" @click="download_item(scope.row)">在线查看</el-link><br/>
              <el-link icon="el-icon-download" @click="download(scope.row,'PDF')">下载PDF发票</el-link><br/>
              <el-link icon="el-icon-download" @click="download(scope.row,'XML')">下载XML发票</el-link><br/>
              <el-link icon="el-icon-download" @click="download(scope.row,'OFD')">下载OFD发票</el-link><br/>
            </span>
            </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>

export default {
  components: { 
  },
  name: "fkqkd",
  data() {
    return {
      options: [{value: '海雅百货南山店',label: '海雅百货南山店'}, 
      {value: '海雅百货东莞东城店',label: '海雅百货东莞东城店'},
      // {value: '海雅百货东莞南城店',label: '海雅百货东莞南城店'},
      {value: '海雅缤纷城购物中心',label: '海雅缤纷城购物中心'},
      {value: '中山海雅缤纷天地',label: '中山海雅缤纷天地'}],
      tableData:[],
      formInline: {
        md:'',
        ksny:'',
        jsny:'',
        hth:'',
        shm:''
      },
      user:JSON.parse(sessionStorage.currentUser),
      conheight: window.innerHeight-136,
      dialogTableVisible: false,
      gridData: []
    };
  },
  methods: {
    download_item(row){//下载发票
      let url = row.f_pdfwj;
      let token = "testtoken";
      let idocvUrl = "http://10.10.10.74:8168";
      //***** 外网 *****/
      if(window.location.origin.indexOf("http://61.144.170.91")>-1){//副线环境
        idocvUrl = "https://idocv.haiya.com.cn";
      }
      if(window.location.origin.indexOf("https://sh.haiya.com.cn")>-1){//副线环境
        idocvUrl = "https://idocv.haiya.com.cn";
      }
      window.app.$http.post(idocvUrl+'/doc/upload?token='+token+'&url='+url).then((resp) => {
        window.open(idocvUrl+"/view/"+resp.data.uuid,"_blank","width=" +(window.screen.availWidth/2) +",height=" +(window.screen.availHeight/2));
      });
    },
    download(row,type){//下载发票
      if(type=='PDF'){
        window.open(row.f_pdfwj);
      }
      if(type=='XML'){
        window.open(row.f_xmlwj);
      }
      if(type=='OFD'){
        window.open(row.f_ofdwj);
      }
    },
    OpenDialog(row){
      this.gridData = [];
      let param = {
          "ghdwdm":row.WLDW,
          "kpny":row.YEARMONTH,
          "hth":row.HTH
      }
      window.app.$http.post(context.bpmRunTime+"/bpm/haiyaapi/getKpmxqk",param).then(resp=>{
        if(resp.data.code==500){
          this.$notify.error({
            title: "未查到本月对应发票，请等待商场方完成开票后下载。",
            duration: 2000
          });
        }else{
          this.gridData = resp.data.data;
          this.dialogTableVisible=true;//打开弹出层
        }
      })
    },
    getDate(currentDate){
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = year+month;
      return formattedDate;
    },
    onSubmit() {
      this.tableData = [];
      let sql = "select * from V_ZSPT_FKQKD where WLDW='"+this.user.account.replaceAll("SZHY","")+"'";
      if(this.formInline.md.length>0){
        sql += " and instr(FDMC,'"+this.formInline.md+"',1,1)>0";
      }
      if(this.formInline.ksny!=null && this.formInline.ksny!='' && this.formInline.jsny!=null && this.formInline.jsny!=''){
        sql += " and YEARMONTH BETWEEN '"+this.getDate(this.formInline.ksny)+"' and '"+this.getDate(this.formInline.jsny)+"'";
      }
      // else{
      //   sql += " and YEARMONTH = to_char(sysdate,'yyyymm')";
      // }
      if(this.formInline.hth.length>0){
        sql += " and instr(HTH,'"+this.formInline.hth+"',1,1)>0";
      }
      if(this.formInline.shm.length>0){
        sql += " and instr(WLDW_NAME,'"+this.formInline.shm+"',1,1)>0";
      }
      sql += " order by YEARMONTH desc";
      this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
          this.tableData = resp.data.result;
        }
      });
    },
    getList(){
      let sql = "select * from V_ZSPT_FKQKD WHERE YEARMONTH BETWEEN to_char(add_months(sysdate,-2),'yyyymm') and to_char(add_months(sysdate,+1),'yyyymm') and WLDW='"+this.user.account.replaceAll("SZHY","")+"' order by YEARMONTH desc";
      this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
          this.tableData = resp.data.result;
        }
      });
    },
    print(row,type){//打印付款请款单
      if(type=='fkqkd'){
        window.open("/fvue/print_fkqkd?JLBH="+row.JLBH+"&HSFS="+row.HSFS,"_blank","width=" + (window.screen.availWidth - 10) +",height=" +(window.screen.availHeight - 70) );
      }
      if(type=='kpqrd'){
        window.open("/fvue/print_kpqrd?JLBH="+row.JLBH+"&HSFS="+row.HSFS,"_blank","width=" + (window.screen.availWidth - 10) +",height=" +(window.screen.availHeight - 70) );
      }
    },

  },
  mounted(){
    this.getList();
    let currentDate = new Date(); // 获取当前日期和时间
    currentDate.setMonth(currentDate.getMonth() - 2); // 将月份减去1
    this.formInline.ksny=currentDate;

    let currentDate1 = new Date(); // 获取当前日期和时间
    currentDate1.setMonth(currentDate1.getMonth() + 1); // 将月份减去1
    this.formInline.jsny=currentDate1;
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .el-table .cell{
  padding: 0px !important;
  text-align: center !important;
}
/deep/ .el-table th{
  // border-right:1px solid #000 !important;
  // border-bottom:1px solid #000 !important;
  .cell{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #292B44;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
/deep/ .el-table td{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #292B44;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  // border-right:1px solid #000 !important;
  // border-bottom:1px solid #000 !important;
}
/deep/ .el-form-item--small .el-form-item__label{
  line-height: 48px !important;
  height: 48px !important;
  color: #292B44 !important;
  font-size: 14px;
}
/deep/ .el-form-item--small .el-form-item__content{
  line-height: 48px !important;
  height: 48px !important;
}
/deep/ .el-form-item el-form-item--small{
  margin: 0px !important;
  line-height: 48px !important;
  height: 48px !important;
}
/deep/ .el-form-item--small.el-form-item{
  margin: 0px !important;
  line-height: 48px !important;
  height: 48px !important;
  padding-right: 32px !important;
}
/deep/ .demo-form-inline{
  // height: 48px !important;
  // line-height: 48px !important;
  padding: 8px 0px !important;
}
/deep/ .chaxun{
  span{
    font-size:14px !important;
  }
}
/deep/ .el-link{
  margin-right: 8px !important;
}
/deep/ .el-link--inner{
  margin: 0px !important;
}
/deep/ .el-drawer__header{
  margin-bottom: 8px;
  font-weight: 400;
  font-size: 14px;
  color: #292B44;
}
</style>